
import * as React from 'react';
import {
  View
} from 'react-native';
import { observer } from 'mobx-react';

import { ParagraphXLRegular } from '../../config/designSystem/typography';
import { useStores } from '../../hooks/useStores';



const ThankYouForReckoning = observer(() => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE?.THANK_YOU;

  return (
    <View style={{  backgroundColor: 'white', flex:1 ,alignItems:'center', justifyContent:'center'}}>
      <ParagraphXLRegular  align={true}>{labels?.TEXT}</ParagraphXLRegular>
    </View>

  );
});


export default ThankYouForReckoning;
